import { jsx as _jsx } from "react/jsx-runtime";
import { Action } from './action';
import { useApiMutation } from '../../../../../../../infra/api';
import { endpoints } from '../../../../../network';
import ResumeCampaignIcon from '../../../../icons/resume-campaign.svg';
import styles from './styles.module.scss';
export var ResumeAction = function (_a) {
    var campaign = _a.campaign, onAfterAction = _a.onAfterAction;
    var resumeRecurringCampaign = useApiMutation({
        endpoint: endpoints.changeRecurringStateMutation,
    });
    var handleResumeClick = function () {
        resumeRecurringCampaign.mutate({
            campaignId: campaign.id,
            recurringState: 'start',
        });
        onAfterAction === null || onAfterAction === void 0 ? void 0 : onAfterAction();
    };
    return (_jsx(Action, { name: "Resume", Icon: ResumeCampaignIcon, onClick: handleResumeClick, id: "resume-campaign-".concat(campaign.id), className: styles['action-button'] }));
};
